var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.show,
        "before-close": _vm.close,
        "close-on-click-modal": false,
        width: "70%",
        height: "90%",
        top: "7vh",
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.show = $event
        },
        open: _vm.openDialog,
      },
    },
    [
      _c(
        "div",
        { staticClass: "dia-tit", attrs: { slot: "title" }, slot: "title" },
        [_c("i"), _c("span", [_vm._v("选择助教")])]
      ),
      _c(
        "el-row",
        { attrs: { gutter: 60 } },
        [
          _c(
            "el-col",
            { attrs: { span: 14 } },
            [
              _c(
                "el-input",
                {
                  staticStyle: { width: "420px", "margin-bottom": "10px" },
                  attrs: { placeholder: "请输入内容" },
                  nativeOn: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.search.apply(null, arguments)
                    },
                  },
                  model: {
                    value: _vm.inputVal,
                    callback: function ($$v) {
                      _vm.inputVal = $$v
                    },
                    expression: "inputVal",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100px" },
                      attrs: { slot: "prepend", placeholder: "请选择" },
                      slot: "prepend",
                      model: {
                        value: _vm.select,
                        callback: function ($$v) {
                          _vm.select = $$v
                        },
                        expression: "select",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "用户名", value: "1" },
                      }),
                      _c("el-option", { attrs: { label: "姓名", value: "2" } }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-button",
                {
                  staticClass: "ml-15",
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.search },
                },
                [_vm._v("查 询")]
              ),
              _c(
                "el-row",
                { attrs: { gutter: 12 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("el-cascader", {
                        staticClass: "w100",
                        attrs: {
                          clearable: "",
                          placeholder: "请选择部门",
                          props: _vm.cascaderProps,
                        },
                        model: {
                          value: _vm.dtDpid,
                          callback: function ($$v) {
                            _vm.dtDpid = $$v
                          },
                          expression: "dtDpid",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "w100",
                          attrs: {
                            placeholder: "请选择角色",
                            clearable: "",
                            filterable: "",
                          },
                          model: {
                            value: _vm.dtPosition,
                            callback: function ($$v) {
                              _vm.dtPosition = $$v
                            },
                            expression: "dtPosition",
                          },
                        },
                        _vm._l(_vm.positionArray, function (item) {
                          return _c("el-option", {
                            key: item.name,
                            attrs: { label: item.name, value: item.name },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-table",
                {
                  ref: "teaRef",
                  staticStyle: { "margin-top": "15px" },
                  attrs: {
                    data: _vm.tableData,
                    border: "",
                    fit: "",
                    "highlight-current-row": "",
                  },
                  on: {
                    select: _vm.handleSelection,
                    "selection-change": _vm.handleSelectionChange,
                    "select-all": _vm.handleSelectionAll,
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { type: "selection", width: "70", align: "center" },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "用户名", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [_vm._v(_vm._s(scope.row.loginName))]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "姓名", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [_c("span", [_vm._v(_vm._s(scope.row.name))])]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c("el-pagination", {
                staticClass: "pagination",
                attrs: {
                  "current-page": _vm.pagination.currentPage,
                  "page-sizes": _vm.pagination.pageSizes,
                  "page-size": _vm.pagination.pageSize,
                  layout: _vm.pagination.layout,
                  total: _vm.pagination.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 10 } },
            [
              _c(
                "el-row",
                {
                  staticStyle: {
                    "box-shadow": "0px 2px 9px 0px rgba(0, 0, 0, 0.15)",
                    "padding-bottom": "30px",
                  },
                },
                [
                  _c("el-row", { staticClass: "seleRow" }, [
                    _c("span", [_vm._v("已选择：")]),
                    _c("span", { staticClass: "seleNum" }, [
                      _vm._v(_vm._s(_vm.multipleSelectionAll.length)),
                    ]),
                  ]),
                  _vm._l(_vm.multipleSelectionAll, function (item, index) {
                    return _c("ul", { key: index, staticClass: "seleList" }, [
                      _c("li", { staticClass: "sele-item" }, [
                        _vm._v(" " + _vm._s(item.name) + " "),
                        _c("i", {
                          staticClass: "el-icon-delete-solid ico-del",
                          on: {
                            click: function ($event) {
                              return _vm.delAssistant(index, item.userId)
                            },
                          },
                        }),
                      ]),
                    ])
                  }),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              staticClass: "dialog-btn",
              attrs: { type: "primary" },
              on: { click: _vm.saveRoleForm },
            },
            [_vm._v("确 定")]
          ),
          _c(
            "el-button",
            {
              staticClass: "dialog-btn",
              attrs: { type: "info" },
              on: { click: _vm.close },
            },
            [_vm._v("取 消")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }